// TrustedOne component - Converted from components/TrustedOne.vue
// Trusted section with count-up animations
// Converted: <template> -> JSX, v-observe-visibility -> useIntersectionObserver, CountUp -> react-countup
// Converted: ref -> useState, :style -> style
import React, { useState, useEffect, useRef } from 'react';
import CountUp from 'react-countup';
import trustedBg from '../assets/images/resources/trusted_one_bg.jpg';

const TrustedOne = () => {
  // Converted from Vue: const startCounter = ref(false) -> useState
  const [startCounter, setStartCounter] = useState(false);
  const sectionRef = useRef(null);

  // Converted from Vue: v-observe-visibility -> IntersectionObserver
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !startCounter) {
            setStartCounter(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [startCounter]);

  return (
    <section ref={sectionRef} className="trusted_one" style={{ backgroundImage: `url(${trustedBg})` }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6">
            <div className="trusted_one_text">
              <h3 style={{fontSize: '3rem',color: 'white'}}>
              Leaders Agro Elite est Votre partenaire de confiance pour une agriculture performante
              </h3>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <ul className="trusted_one_counter_box list-unstyled wow fadeInRight" data-wow-delay="100ms">
              <li className="trusted_one_couter_single">
                <div className="trusted_one_couter_icon">
                  <i className="icon-watering"></i>
                </div>
                <h3>
                  <span className="counter">
                    <CountUp start={0} end={startCounter ? 30 : 0} duration={2.5} />
                  </span>
                </h3>
                <p>Projets</p>
              </li>
              <li className="trusted_one_couter_single">
                <div className="trusted_one_couter_icon">
                  <i className="icon-wheelbarrow"></i>
                </div>
                <h3>
                  <span className="counter">
                    <CountUp start={0} end={startCounter ? 100 : 0} duration={2.5} />
                  </span>
                </h3>
                <p>Produits</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedOne;
